/** Query keys in one place so realtime handlers and mutations can invalidate precisely (moved from apps/web, Phase 0). */
export const qk = {
  me: ['me'] as const,
  conversations: (ws: string) => ['conversations', ws] as const,
  navBadges: (ws: string) => ['nav-badges', ws] as const,
  navFollows: (ws: string) => ['nav-follows', ws] as const,
  shortcuts: (ws: string) => ['shortcuts', ws] as const,
  conversation: (id: string) => ['conversation', id] as const,
  members: (ws: string) => ['members', ws] as const,
  presence: (ws: string) => ['presence', ws] as const,
  notifications: (ws: string) => ['notifications', ws] as const,
  projects: (ws: string) => ['projects', ws] as const,
  project: (id: string) => ['project', id] as const,
  tasks: (projectId: string) => ['tasks', projectId] as const,
  task: (id: string) => ['task', id] as const,
  myTasks: (ws: string) => ['my-tasks', ws] as const,
  pins: (id: string) => ['pins', id] as const,
  teams: (ws: string) => ['teams', ws] as const,
  chatSections: (ws: string) => ['chat-sections', ws] as const,
  taskLinks: (conversationId: string) => ['task-links', conversationId] as const,
  thread: (id: string) => ['thread', id] as const,
  wf: (ws: string, ...rest: unknown[]) => ['wf', ws, ...rest] as const,
  /** Under the 'wf' prefix so every workforce invalidation (clock, shifts, requests) refreshes Today too. */
  today: (ws: string) => ['wf', ws, 'me-today'] as const,
  peopleDirectory: (ws: string | null) => ['people-directory', ws] as const,
  person: (ws: string | null, id: string | null) => ['person', ws, id] as const,
  search: (ws: string | null, q: string, type: string) => ['search', ws, q, type] as const,
  /** Fleet keys share the web's ['fleet', ws, …] prefix so its invalidations reach them. */
  fleet: (ws: string | null, ...rest: unknown[]) => ['fleet', ws, ...rest] as const,
  /** t413u: HR changes waiting for my approval (Home widget and the phone's Today strip). Under ['hr', ws] so HR pages' invalidations reach it. */
  hrApprovals: (ws: string | null) => ['hr', ws, 'approvals'] as const,
  hrMissing: (ws: string | null) => ['hr', ws, 'missing'] as const,
  hrStartersLeavers: (ws: string | null, from: string, to: string) => ['hr', ws, 'starters-leavers', from, to] as const,
  hrErasure: (ws: string | null, userId: string) => ['hr', ws, 'erasure', userId] as const,
};
